module.exports = "<p>\r\n  logout works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/logout/logout.component.html
// module id = ../../../../../src/app/logout/logout.component.html
// module chunks = main